import request from '@/utils/request'

// 查询卡号定时任务
export function findSimCardScheduledTasks(params) {
  return request({
    url: `/sim_card_scheduled_tasks`,
    method: 'get',
    params: params
  })
}

// 取消卡号定时任务
export function cancelSimCardScheduledTask(id) {
  return request({
    url: `/sim_card_scheduled_tasks/${id}/cancel`,
    method: 'post'
  })
}
